var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarShipworksBishop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 546.59 505.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#7a7479;}.cls-3{fill:#5b4d57;}.cls-4{fill:#443542;}.cls-5{fill:#c1c1c1;}.cls-6{fill:#2b2b2b;}.cls-7{fill:#5b5b5b;}.cls-8{fill:#0a0a0a;}.cls-10,.cls-9{fill:#a6b9bc;stroke:#60410b;stroke-miterlimit:10;}.cls-9{stroke-width:11px;}.cls-10{stroke-width:6px;}.cls-11{fill:#fff;mix-blend-mode:lighten;opacity:0.5;}.cls-12{fill:#594f43;}.cls-13{fill:#303030;}.cls-14{fill:#565759;}.cls-15{fill:#474747;}.cls-16{fill:#7c889b;}.cls-17{fill:#393a3a;}.cls-18{fill:#454647;}.cls-19{fill:#f99615;}.cls-20{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mechanic"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "546.59 505.25 0 505.25 20 426 60 387.52 276.01 311.92 486.59 387.52 526.59 426 546.59 505.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "428.17 505.33 118.42 505.33 145.34 373.67 401.25 373.67 428.17 505.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 166.42,
    y: 308.75,
    width: 28.5,
    height: 83.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 351.67,
    y: 308.75,
    width: 28.5,
    height: 83.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.56 95.55 156.04 129.75 134.16 278.93 167.13 341.03 208.38 373.67 273.56 386.32 339.24 374.72 379.99 341.03 412.96 278.93 391.08 129.75 273.56 95.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "273.56 331.53 240.05 307.17 273.56 292.66 307.07 307.17 273.56 331.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "300.54 350.02 273.56 345.44 246.58 350.02 238.23 347.07 273.56 336.25 308.89 347.07 300.54 350.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.35 337.25 272.77 337.25 269.6 327.75 277.52 327.75 274.35 337.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "221.57 283.45 194.33 283.11 193.82 244.84 233.41 222.8 242.57 232.38 246.25 255.63 221.57 283.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "326.62 284 353.86 283.66 354.37 245.39 314.78 223.35 305.62 232.94 301.94 256.18 326.62 284"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "114.17 108.96 114.17 169.86 149.65 180.5 190.95 166.85 202.6 116.24 159.87 85.15 114.17 108.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "437.18 108.96 437.18 165.46 401.7 180.5 360.4 166.85 348.75 116.24 395.87 85.15 437.18 108.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 358.76,
    y1: 255.92,
    x2: 405.19,
    y2: 234.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 188.23,
    y1: 255.87,
    x2: 148.61,
    y2: 237.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 260.3,
    y1: 255.77,
    x2: 286.7,
    y2: 255.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 258.63,
    y1: 242.64,
    x2: 288.38,
    y2: 242.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "354.91 241.05 290.52 241.05 286.68 245.35 286.68 293.06 290.52 297.36 354.91 297.36 358.76 293.06 358.76 245.35 354.91 241.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "256.46 241.11 192.07 241.11 188.23 245.42 188.23 293.12 192.07 297.43 256.46 297.43 260.3 293.12 260.3 245.42 256.46 241.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.42 373.67 121.55 373.67 121.55 330.92 166.42 345.08 166.42 373.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "380.17 373.67 425.04 373.67 425.04 330.92 380.17 345.08 380.17 373.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "247.25 294.17 231.48 294.17 197.43 244.57 213.2 244.57 247.25 294.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "345.62 294.42 329.85 294.42 295.79 244.82 311.56 244.82 345.62 294.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "415.57 214.07 276.94 207.74 138.32 214.07 138.32 190.73 276.94 184.39 415.57 190.73 415.57 214.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "133.22 246.86 145.12 247.45 145.12 192.43 133.22 192.43 133.22 246.86"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 145.12,
    y: 190.73,
    width: 6.8,
    height: 56.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 401.96,
    y: 190.73,
    width: 6.8,
    height: 56.13,
    transform: "translate(810.73 437.59) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "133.1 191.56 132.55 202.63 184.37 178 364.06 178 420.93 202.63 421.34 191.56 353.34 146.46 191.04 146.46 133.1 191.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "420.93 191.65 375.18 166.2 186.79 166.2 132.55 191.65 189.1 24.84 211.27 13.53 338.99 13.53 364.38 24.84 420.93 191.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "321.8 81.12 337.57 81.12 328.56 36.06 321.8 33.81 321.8 81.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "229.43 81.12 213.66 81.12 222.67 36.06 229.43 33.81 229.43 81.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "326.31 65.35 224.92 65.35 229.43 33.81 321.8 33.81 326.31 65.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "337.57 81.12 213.66 81.12 224.92 65.35 326.31 65.35 337.57 81.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "367.1 166.11 421.34 191.56 364.79 24.75 342.62 13.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "306.03 65.35 290.26 65.35 245.2 33.81 260.97 33.81 306.03 65.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "211.81 13.44 189.64 24.75 133.1 191.56 187.33 166.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "420.67 246.86 408.77 247.45 408.77 192.43 420.67 192.43 420.67 246.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "339 93.42 212.34 93.42 213.92 88.67 337.42 88.67 339 93.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "340.45 104.5 210.62 104.5 212.2 99.75 338.87 99.75 340.45 104.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 167.1,
    y: 409.97,
    width: 11.99,
    height: 11.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 186.27,
    y: 409.97,
    width: 11.99,
    height: 11.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 244.38,
    y: 409.89,
    width: 58.64,
    height: 11.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 205.44,
    y: 409.97,
    width: 32.23,
    height: 11.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 46.09,
    width: 456,
    height: 456
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarShipworksBishop);
export default __webpack_public_path__ + "static/media/avatar-shipworks-bishop.d662b18b968c768e2a64409a7d72fa42.svg";
export { ForwardRef as ReactComponent };